<template>
  <div>
    &nbsp;
    <el-row>
      <el-col :span="16" class="layout-col">
        <div class="query-form-container">
          <query-form-builder :entityPropertys="entityPropertys" :formData="queryFormData" :colsOfRow="queryFormColsOfRow" ref="queryForm"></query-form-builder>
          <div class="query-btn-container">
            <el-button @click="query">查询</el-button>
            <el-button @click="resetForm('queryForm')">重置</el-button>
          </div>
        </div>
        <el-card class="table-card" :body-style="{ padding: '0px' }">
          <div slot="header" class="table-card-header">
            <span>用户信息</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="
                editFormData = {}
                editDialogStatus = 1
              "
              >新增</el-button
            >
          </div>
          <el-table :data="tableData" border highlight-current-row @current-change="handleCurrentChange" style="width: 100%" ref="table">
            <el-table-column type="index" width="50" :index="lineNumber"></el-table-column>
            <!-- <el-table-column v-for="(item, index) in queryListPropertys" :key="index" :prop="item.propertyName" :label="item.chineseName" :width="item.width" align="center" :show-overflow-tooltip="true"></el-table-column> -->
            <el-table-column label="邮箱" prop="mail" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="姓名" prop="nameZh" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="公司" prop="companyZh" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="用户组" prop="dutiesId_nameZh" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="orderBy" label="排序"></el-table-column>
            <el-table-column fixed="right" label="操作" width="100" align="center">
              <template slot-scope="scope">
                <i
                  class="el-icon-search"
                  title="查看"
                  @click="
                    editFormData = scope.row
                    detailDialogStatus = 1
                  "
                ></i>
                <i
                  class="el-icon-edit"
                  title="修改"
                  @click="
                    editFormData = Object.assign({}, scope.row)
                    editDialogStatus = 2
                  "
                ></i>
                <i class="el-icon-delete" title="删除" @click="deleteTableData(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next" :total="totalElements" :page-size="pageSize" :current-page="pageNumber + 1" @current-change="tablePaging"></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="6" class="layout-col">
        <user-role :userId="userId"></user-role>
      </el-col>
    </el-row>

    <el-dialog title :visible="true" @close="editDialogClose" width="50%" v-if="editDialogStatus != 0">
      <edit-form-builder :entityPropertys="SaveEntityPropertys" :formData="editFormData" :colsOfRow="editFormColsOfRow" :formStatus="editDialogStatus" ref="editForm"></edit-form-builder>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogStatus = 0">取 消</el-button>
        <el-button type="primary" @click="saveEditFormData">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title :visible="true" @close="detailDialogClose" width="75%" v-if="detailDialogStatus != 0">
      <detail-table-builder :entityPropertys="entityPropertys" :rowData="editFormData" :colsOfRow="detailTableColsOfRow"></detail-table-builder>
    </el-dialog>
  </div>
</template>
<script>
// import QueryFormBuilder from '@/components/form-builder/query-form-builder'   这三个组件全局注册，无需再次导入
// import EditFormBuilder from '@/components/form-builder/edit-form-builder'
// import DetailTableBuilder from '@/components/form-builder/detail-table-builder'
import { Component, Vue } from 'vue-property-decorator'
import UserRole from './UserRole.vue'
import Table from '@/plugins/table'

@Component({
  name: 'User',
  components: {
    UserRole
  }
})
// Table这个类集成了table模板所需的公共属性和公共方法，若要修改，请覆盖方法。一般情况继承 Vue 即可
export default class User extends Table {
  userId = null
  queryFormData = {
    ne_id: this.$store.getters.userId !== '1' ? '1' : '',
    sl_organization: this.$store.getters.organizationPrefix
  }
  entityPropertys = [
    {
      name: 'mail', // 对应数据表的属性名字
      chineseName: '邮箱', //前端显示的中文名
      inputType: '01', //输入类型
      colspan: 1, //占据宽度
      appearPlace: '01,02,03,04', // 01 编辑新增 02 查询 03表格 04详情
      querySymbol: 'eq', //查询前缀
      inputValidateType: '01' //验证规则
    },
    {
      name: 'nameZh',
      chineseName: '姓名',
      inputType: '01',
      colspan: 1,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk'
    },
    {
      name: 'companyZh',
      chineseName: '公司',
      inputType: '01',
      colspan: 1,
      width: 100,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk'
    },
    {
      name: 'dutiesId',
      chineseName: '用户组',
      inputType: '31',
      dicName: 'D_USER_GROUP_ZH',
      changeOnSelect: true,
      colspan: 1,
      appearPlace: '01,02,03,04',
      querySymbol: 'eq'
    }
  ]
  SaveEntityPropertys = [
    {
      name: 'mail', // 对应数据表的属性名字
      chineseName: '邮箱', //前端显示的中文名
      inputType: '01', //输入类型
      colspan: 4, //占据宽度
      appearPlace: '01,02,03,04', // 01 编辑新增 02 查询 03表格 04详情
      querySymbol: 'eq', //查询前缀
      inputValidateType: '01' //验证规则
    },
    {
      name: 'nameZh',
      chineseName: '姓名(中)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'nameEn',
      chineseName: '姓名(英)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'companyZh',
      chineseName: '公司(中)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'companyEn',
      chineseName: '公司(英)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'positionZh',
      chineseName: '职位(中)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'positionEn',
      chineseName: '职位(英)',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'lk',
      inputValidateType: '01'
    },
    {
      name: 'dutiesId',
      chineseName: '用户组',
      inputType: '31',
      dicName: 'D_USER_GROUP_ZH',
      changeOnSelect: true,
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'eq',
      inputValidateType: '01'
    },
    {
      name: 'orderBy',
      chineseName: '序号',
      inputType: '01',
      colspan: 4,
      appearPlace: '01,02,03,04',
      querySymbol: 'eq',
      inputValidateType: '01'
    }
  ]

  created() {
    this.fetchTableData()
  }

  fetchTableData() {
    this.axios({
      url: '/iblac/user/search',
      method: 'get',
      params: Object.assign(
        {
          page: this.pageNumber,
          size: this.pageSize,
          sort: 'orderBy,asc'
        },
        this.queryFormData
      )
    })
      .then(response => {
        const data = response.data
        this.tableData = data.content
        this.totalElements = data.totalElements
        this.$nextTick(() => {
          if (this.tableData.length > 0) {
            var currentRow = this.$refs.table
            currentRow.setCurrentRow(this.tableData[0])
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  }

  saveEditFormData() {
    this.axios({
      url: this.editDialogStatus === 1 ? '/iblac/user/sysUsers' : '/iblac/user/info',
      method: this.editDialogStatus === 1 ? 'post' : 'put',
      data: this.editFormData
    })
      .then(response => {
        this.signSave(this.editFormData, response.data.id)
        const data = response.data
        if (data === '') {
          this.$message('用户名已存在')
          return
        }
        if (this.editDialogStatus === 1) {
          this.tableData.unshift(data)
          this.totalElements = this.totalElements + 1
          this.$refs.table.setCurrentRow()
          this.$nextTick(() => {
            this.$refs.table.setCurrentRow(this.tableData[0])
          })
        } else {
          this.tableData = this.tableData.map(item => {
            return item.id === data.id ? data : item
          })
        }
        this.editDialogStatus = 0
        this.$message('操作成功')
      })
      .catch(error => {
        console.log(error)
        if (error == 'Error: Request failed with status code 403') {
          this.$message({
            message: '不允许访问',
            type: 'warning'
          })
        } else {
          this.$message('操作失败')
        }
      })
  }

  signSave(formValue, id) {
    this.axios({
      url: '/iblac/user/signSave',
      method: 'post',
      data: formValue,
      params: { id: id }
    })
      .then(response => {
        console.log('签字验签返回的数据为：', response)
      })
      .catch(error => {
        console.log(error)
      })
  }

  deleteTableData(row) {
    this.$confirm('确定删除【' + row.nameZh + '】吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.axios({
          url: '/iblac/user/sysUsers/' + row.id,
          method: 'delete'
        })
          .then(response => {
            this.fetchTableData()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
          .catch(error => {
            console.log(error)
            if (error == 'Error: Request failed with status code 403') {
              this.$message({
                message: '不允许访问',
                type: 'warning'
              })
            } else {
              this.$message('删除失败!')
            }
          })
      })
      .catch(() => {})
  }

  handleCurrentChange(row) {
    if (!row) {
      return
    }
    this.userId = row.userId
  }
}
</script>
<style scoped>
.layout-col {
  text-align: center;
}
.search-input {
  width: 80%;
  margin: 5px;
}

.table-card-header {
  text-align: left;
}
.dialog-footer {
  text-align: center;
}
.el-icon-search,
.el-icon-edit,
.el-icon-delete {
  cursor: pointer;
}
.query-form-container {
  padding: 5px;
}
.query-btn-container {
  text-align: center;
}
</style>
